import { Box, Button, Stack, Typography, styled, BottomNavigation } from "@mui/material";
import AwardCard from "components/datadisplay/cards/AwardCard";
import SliderGeneral from "components/datadisplay/slider/SliderGeneral";
import React, { useEffect, useState } from "react";
import img1 from "../assets/images/slider1.webp"
import img2 from "../assets/images/slider2.webp"
import img3 from "../assets/images/slider3.webp"
import useFetch from "services/hooks/useFetch";
import { ApiUrls, urlAwardsPage } from "services/utils/globalVariables";
import { NotfoundText, PageHeading } from "components/typography/text";
import { AwardsCardLoader } from "components/loaders/AwardsLoaders";
import { useNavigate } from "react-router-dom";
import getExternalPrize from "services/utils/GetExternalPrize";

//Static slide images
const slides = [
    {
        Src: img1,
        Alt: "راهنمای باشگاه مشتریان 1"
    },
    {
        Src: img2,
        Alt: "راهنمای باشگاه مشتریان 2"
    },
    {
        Src: img3,
        Alt: "راهنمای باشگاه مشتریان 3"
    }
]

const SliderContainer = styled(Box)(
    ({ theme }) => `
        width: 100%;
        height: auto;
        margin-top: 2px;
        display: block;
    `
)

const AwardsContainer = styled(Stack)(
    ({ theme }) => `
        width: 100%;
        margin-top: ${-(theme.spacing(2))};
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
    `
)

const ShowMoreButton = styled(Button)(
    ({ theme }) => `
        width: 100%;
        color: ${theme.palette.secondary.main} !important;
        margin-top: ${theme.spacing(3)};
    `
)

export default function HomePage() {

    const [{ response, isLoading, error }, doFetch] = useFetch(ApiUrls.GetPrize, "get")
    const navigate = useNavigate()

    useEffect(() => {
        doFetch()
    }, [])

    //Navigating to awards page
    const handleNavigateAwards = () => {
        navigate(urlAwardsPage)
    }

    return (
        <Stack sx={{direction: "ltr !important"}}>
            <SliderContainer>
               <SliderGeneral Slides={slides} />
            </SliderContainer>
            <Stack spacing={1} sx={{mt: 3, padding: "0 16px"}}>
                <PageHeading>جوایز منتخب</PageHeading>
                {
                    isLoading ?
                    <AwardsContainer>
                        {
                            response.Data.slice(0, 6).map((val, i) => {
                               return <AwardCard key={i} data={val} />
                            })
                        }
                        {
                            response.Data.length == 0 &&
                            <Stack sx={{py: 4}}>
                                <NotfoundText>موردی وجود ندارد</NotfoundText>
                            </Stack>
                        }
                        <ShowMoreButton onClick={handleNavigateAwards} size="large" color="btnGrey" variant="contained" >
                            مشاهده بیشتر
                        </ShowMoreButton>
                    </AwardsContainer>
                    : <AwardsCardLoader />
                }
            </Stack>
        </Stack>
    )
}